<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar></app-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer></app-footer>

    <div bsModal #notificationModal="bs-modal" class="modal fade" tabindex="-1"  [config]="{backdrop: 'static', keyboard: false}">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title text-primary">{{notification?.title}}</h5>
                      <button type="button" class="btn-close" aria-label="Close" (click)="closeNotification()"></button>
                  </div>
                  <div class="modal-body">

                      <div class="col-md-12 mb-3 mt-3">
                          <div [innerHTML]="notification?.content"></div>
                      </div>

                  </div>
                  <div class="modal-footer">
                      <button type="button" (click)="closeNotification()" class="btn btn-primary waves-effect">{{"COMMON.cancel" | translate}}</button>
                  </div>
              </div>
          </div>
    </div>

  </div>
</div>